import React from "react";

import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";

import Navbar from "../../components/Navbar";
import S2 from "../../sections/S2_Whatwedo";
import S3 from "../../sections/S3_Services";
import S4 from "../../sections/S4_Time";
import S5 from "../../sections/S5_Construction";
import S6 from "../../sections/S6_Development";
import S7 from "../../sections/S7_Message";
import S8 from "../../sections/S8_Footer";

import bgimg from "../../images/bgimg1.png";
import phonecall from "../../images/call.png";

const Wrapper = styled.div`
  height: 100vh;
  background-image: url(${bgimg});
  background-position: center;
  background-size: cover;
`;
const Cells = styled.div`
  // padding-left: 60px;
  width: 90%;
  // text-align: left;
  color: white;
  font-family: poppins;
`;
const Title = styled.div`
  padding-top: 80px;
  font-size: 80px;
  font-weight: 900;
  line-height: 80px;
  @media (max-width: 1199px) {
    line-height: 40px;
    font-weight: 600;
    font-size: 45px;
  }
  @media (max-width: 599px) {
    padding-top: 30px;
  } ;
`;

const Box2 = styled.div`
  padding-top: 20px;
  // border-bottom: 1px solid #909ea8;
  width: 70%;
  @media (max-width: 599px) {
    width: 100%;
  } ;
`;
const PhoneCall = styled.div`
  color: #ffffff;
  border-radius: 50px 0px 0px 50px;
  position: absolute;
  bottom: 30px;
  right: 0;
  cursor: pointer;
  font-weight: 600;
  font-family: poppins;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid rgba(255, 255, 255, 0.18);
  padding: 20px 25px 10px 30px;
  @media (max-width: 899px) {
    bottom: 10px;
  }
`;
const PhoneText = styled.div`
  padding-left: 12px;
`;
const HotLine = styled.div`
  padding-top: 10px;
`;
const PhoneImg = styled.div`
  display: flex;
  padding-top: 10px;
`;

const Index = () => {
  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div>
      <Wrapper>
        <Navbar />
        <Container maxWidth="xl">
          <Grid container>
            <Grid xs={12} md={6}>
              <Cells>
                <Title>Make your Home a Dreamland</Title>
                <Box2>
                  At Paramount Vault, we're determined to turn your vision into
                  reality! With cutting-edge technologies like solar panels,
                  elevators, pre-fabricated structures, and recharge bore pumps,
                  build or renovate your home in the most energy-efficient
                  manner.
                  <br /> All of our products are efficient, reliable, and of a
                  high standard... What more is there to ask for!?
                </Box2>
              </Cells>
            </Grid>
            <Grid xs={12} md={6}>
              <a href="tel: +92 333 5702025">
                <PhoneCall>
                  <PhoneText>
                    In a hurry? Tap and get on a call with us!
                  </PhoneText>
                  <PhoneImg>
                    <img src={phonecall} alt="call" />
                    <HotLine>
                      Hotline 24/7
                      <br />
                      +92 333 5702025
                    </HotLine>
                  </PhoneImg>
                </PhoneCall>
              </a>
            </Grid>
          </Grid>
        </Container>
      </Wrapper>
      <S2 />
      <S3 />
      <S4 />
      <S5 />
      <S6 />
      <S7 />
      <S8 />
    </div>
  );
};
export default Index;
